'use client';

import React from 'react';
import { FileText, X, ExternalLink } from 'lucide-react';

interface DocumentPreviewModalProps {
  selectedDocUrl: string | null;
  onClose: () => void;
}

export const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({
  selectedDocUrl,
  onClose,
}) => {
  if (!selectedDocUrl) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-md flex items-center justify-center p-4">
      <div className="bg-[#0A0D1A] border border-slate-800 rounded-3xl max-w-3xl w-full p-6 space-y-4 shadow-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-bold text-white flex items-center gap-2">
            <FileText className="w-4 h-4 text-indigo-400" />
            <span>KYC Identity Proof Attachment</span>
          </h3>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white p-1.5 hover:bg-slate-800 rounded-xl transition-colors cursor-pointer"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1 bg-[#060811] border border-slate-800 rounded-2xl p-4 flex flex-col items-center justify-center min-h-[300px] overflow-hidden">
          {/\.(jpg|jpeg|png|webp|gif)($|\?)/i.test(selectedDocUrl) ? (
            <img
              src={selectedDocUrl}
              alt="KYC Document"
              className="max-h-[60vh] max-w-full object-contain rounded-xl shadow-md"
            />
          ) : /\.(pdf)($|\?)/i.test(selectedDocUrl) ? (
            <iframe
              src={selectedDocUrl}
              title="KYC PDF Document"
              className="w-full h-[60vh] rounded-xl border border-slate-800"
            />
          ) : (
            <div className="text-center py-10 space-y-3">
              <FileText className="w-12 h-12 text-indigo-400 mx-auto opacity-70" />
              <p className="text-xs text-slate-300 font-medium">Document Attachment Ready</p>
            </div>
          )}
        </div>

        <div className="pt-2 flex items-center justify-between">
          <a
            href={selectedDocUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-slate-900 hover:bg-slate-800 border border-slate-700 text-slate-200 font-bold text-xs rounded-xl transition-all"
          >
            <ExternalLink className="w-4 h-4 text-indigo-400" />
            <span>Open Original File in New Tab</span>
          </a>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white font-bold text-xs rounded-xl cursor-pointer"
          >
            Close Preview
          </button>
        </div>
      </div>
    </div>
  );
};
